// src/routes/Mockup/index.tsx
import { useId } from "react";
import "./index.css";
import mockup from "../../assets/mockup.png";
import mockuplogo from "../../assets/mockuplogo.png";

export default function Mockup({
  title,
  photoUrl,
}: {
  title: string;
  photoUrl: string;
}) {
  const clipId = useId(); // уникальный id для каждого инстанса

  // точный размер исходника
  const W = 800;
  const H = 1083;
  const LABEL_W = 200; // ширина области под текст (px во viewBox)
  const LABEL_H = 80;

  // координаты «этикетки» (подгони раз и навсегда под свой PNG)
  // Ниже пример: квадрат 150×150 и подпись ниже по центру
  const LABEL_X = 265; // левый край области этикетки
  const LABEL_Y = 520; // верхний край
  const PHOTO = { x: 344, y: 576, w: 102, h: 102, r: 0 }; // окно под фото
  const TITLE = { x: 393, y: 790, size: 20 }; // центр и размер шрифта

  return (
    <div className="mock">
      <svg
        viewBox={`0 0 ${W} ${H}`}
        preserveAspectRatio="xMidYMid meet"
        className="mock-svg"
      >
        {/* фон — пустой флакон */}
        <image href={mockup} x="0" y="0" width={W} height={H} />

        {/* <clipPath id="photoClip">
            <rect x={620} y={30} width={150} height={230} rx={12} ry={12} />
        </clipPath>

        {photoUrl && (
            <image
              href={photoUrl}
              x={620}
              y={30}
              width={150}
              height={230}
              preserveAspectRatio="xMidYMid slice"
              clipPath="url(#photoClip)"
            />
          )} */}


        {/* группа этикетки */}
        <g id="label" transform={`translate(${LABEL_X}, ${LABEL_Y})`}>
          {/* клип для фото */}
          <clipPath id={clipId}>
            <rect
              x={PHOTO.x - LABEL_X}
              y={PHOTO.y - LABEL_Y}
              width={PHOTO.w}
              height={PHOTO.h}
              rx={PHOTO.r}
            />
          </clipPath>

          {/* фото пользователя */}
          {photoUrl && (
            <image
              href={photoUrl}
              x={PHOTO.x - LABEL_X}
              y={PHOTO.y - LABEL_Y}
              width={PHOTO.w}
              height={PHOTO.h}
              clipPath={`url(#${clipId})`}
              preserveAspectRatio="xMidYMid slice"
            />
          )}

          <image
            href={mockuplogo}
            x={PHOTO.x - LABEL_X}
            y={PHOTO.y - LABEL_Y}
            width={PHOTO.w}
            height={PHOTO.h}
          />

          

          {/* название */}
        </g>
        <foreignObject
          x={TITLE.x - LABEL_W / 2}
          y={TITLE.y - LABEL_H / 2}
          width={LABEL_W}
          height={LABEL_H}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              textAlign: "center",
              fontFamily: "TTDrugs, system-ui",
              fontWeight: 800,
              fontSize: `${TITLE.size}px`,
              color: "#111",
              lineHeight: "1.1",
              overflow: "hidden",
            }}
          >
            <span
              style={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 2, // максимум 2 строки
                overflow: "hidden",
                // перенос длинных слов/без пробелов:
                wordBreak: "break-word",
                overflowWrap: "anywhere",
              }}
            >
              {title}
            </span>
          </div>
        </foreignObject>
      </svg>
    </div>
  );
}
